//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../Features/Features.StructureDesign.Frame3DBuilder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/ugmath.js";
import "../no/SelectObjectList.js";
let d=[[[1,"FirstLine",0,"SelectDisplayableObjectList",0],[1,"SecondLine",0,"SelectDisplayableObjectList",0]],[[["draggedToPosition"],"CreateAndDragFilletToPosition",{R_:{fillet:"Arc"}},1,0],[["radius"],"CreateFilletFromRadius",{R_:{fillet:"Arc"}},1,0],[[],"InitializeQuadrantData",{},0,0]],[]];
SPLM.Features.StructureDesign.Frame3DFilletBuilder = class extends SPLM.Features.StructureDesign.Frame3DBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.Frame3DFilletBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;